import React from 'react';
import { MapPinIcon, ShirtIcon, InfoIcon, InstagramIcon, FacebookIcon, YoutubeIcon, TwitterIcon } from '@/components/icons';
import type { Event, Business } from '@/features/events/types/types';

interface AboutSectionProps {
  eventInfo: Event;
  businessInfo: Business;
}

const AboutSection: React.FC<AboutSectionProps> = ({ eventInfo, businessInfo }) => {
  return (
    <section>
      <div className="space-y-8">
        <div>
          <h2 className="text-3xl font-serif font-medium text-white mb-4">
            About {businessInfo.name}
          </h2>
          <p className="text-gray-400 leading-relaxed">
            {businessInfo.description}
          </p>
        </div>
        <div className="space-y-4">
          <div className="flex items-start gap-4">
            <MapPinIcon className="w-5 h-5 mt-1 text-blue-400 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-white">Location</h3>
              <p className="text-gray-400">
                {`${businessInfo.location.address_line1}, ${businessInfo.location.city}`}
              </p>
            </div>
          </div>
          
          {eventInfo.dress_code && (
            <div className="flex items-start gap-4">
              <ShirtIcon className="w-5 h-5 mt-1 text-blue-400 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-white">Dress Code</h3>
                <p className="text-gray-400">{eventInfo.dress_code}</p>
              </div>
            </div>
          )}
          
          {businessInfo.age_requirements && (
            <div className="flex items-start gap-4">
              <InfoIcon className="w-5 h-5 mt-1 text-blue-400 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-white">Age Policy</h3>
                <p className="text-gray-400">{businessInfo.age_requirements.notes}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {businessInfo.social_media_links && (
        <div className="mt-12 flex flex-wrap items-center gap-x-6 gap-y-4">
          <h3 className="text-sm font-semibold text-gray-400">Follow the Venue:</h3>
          <div className="flex items-center gap-4">
            {businessInfo.social_media_links.instagram && (
              <a 
                href={businessInfo.social_media_links.instagram} 
                className="text-gray-500 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon className="w-5 h-5" />
              </a>
            )}
            {businessInfo.social_media_links.facebook && (
              <a 
                href={businessInfo.social_media_links.facebook} 
                className="text-gray-500 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon className="w-5 h-5" />
              </a>
            )}
            {businessInfo.social_media_links.twitter && (
              <a 
                href={businessInfo.social_media_links.twitter} 
                className="text-gray-500 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon className="w-5 h-5" />
              </a>
            )}
            {businessInfo.social_media_links.youtube && (
              <a 
                href={businessInfo.social_media_links.youtube} 
                className="text-gray-500 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeIcon className="w-5 h-5" />
              </a>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutSection;
